<template>
	<div class="vx-col w-full py-5 px-5" :key="detailBoxRefreshKey">
		<div class="vx-row mb-5">
			<div
				class="vx-col"
				style="
					display: flex;
					flex-direction: column;
					justify-content: space-between;
				"
			>
				<div
					style="
						display: flex;
						flex-direction: row;
						justify-content: space-between;
					"
				>
					<vs-input
						class="w-1/2 mr-10"
						label="Nom de la recherche *"
						placeholder="Ma recherche 1"
						v-model="prospectSearch.name"
						:danger="fieldValidatior.name.danger"
						:danger-text="fieldValidatior.name.message"
						@change="validateAllField"
					/>
					<vs-input
						class="w-1/2"
						label="Domaine d'activité *"
						placeholder="Référencement"
						:danger="fieldValidatior.domain_activity.danger"
						:danger-text="fieldValidatior.domain_activity.message"
						v-model="prospectSearch.domain_activity"
						@change="validateAllField"
					/>
				</div>
				<div
					style="
						display: flex;
						flex-direction: row;
						justify-content: space-between;
					"
				>
					<vs-select
						v-if="$acl.check('sadmin')"
						autocomplete
						label="Motueur de recherche *"
						v-model="prospectSearch.search_engine_id"
						class="w-3/4 mt-4 mr-10"
						placeholder="Motueur de recherche"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in search_engines"
							class="w-full"
						/>
					</vs-select>
					<vs-select
						v-if="$acl.check('sadmin')"
						autocomplete
						:key="countryListKey"
						label="Localisation *"
						v-model="prospectSearch.location_id"
						class="w-2/4 mr-5 mt-4"
						placeholder="Pays"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.location_name"
							v-for="(item, index) in country_list"
							class="w-full"
						/>
					</vs-select>
					<vs-select
						:key="languageListKey"
						v-if="$acl.check('sadmin')"
						autocomplete
						label="Langue *"
						v-model="prospectSearch.language_id"
						class="w-2/4 mt-4"
						placeholder="Langue"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in search_engines_languages"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
		</div>
		<!-- End project details -->
		<hr class="m-10" />
		<!-- Start methods choose -->
		<div
			style="display: flex; flex-direction: row; justify-content: space-between"
			:class="{ 'disabled-div': typeDisabled }"
			@click.prevent="handleClick"
		>
			<div
				style="
					display: flex;
					flex-direction: row;
					justify-content: space-evenly;
					gap: 20px;
				"
			>
				<div class="w-1/2 pb-10 disabled-div">
					<vs-card class="card-url">
						<div slot="header" @click.stop>
							<vs-checkbox v-model="isByUrl" disabled></vs-checkbox>
							<h3 class="text-center">Via URLs</h3>
						</div>
						<div>
							<span>
								Importez des prospects en fournissant directement des URLs de
								sites web. Cette méthode est idéale pour cibler des entreprises
								spécifiques dont vous connaissez déjà les sites. Le système
								extraira automatiquement les informations de contact et d'autres
								données pertinentes à partir des pages web fournies.
							</span>
						</div>
					</vs-card>
				</div>
				<div class="w-1/2 pb-10 disabled-div">
					<vs-card class="card-url">
						<div slot="header" @click.stop>
							<vs-checkbox v-model="isByKeyword" disabled></vs-checkbox>
							<h3 class="text-center">Via Mots-clés</h3>
						</div>
						<div>
							<span>
								Trouvez des prospects en utilisant des mots-clés spécifiques à
								votre secteur d'activité. Cette méthode permet de découvrir des
								entreprises pertinentes en fonction de leur présence en ligne.
								Le système recherchera des sites web contenant vos mots-clés et
								extraira les informations de contact associées.
							</span>
						</div>
					</vs-card>
				</div>
				<div @click="toogleType(3)" class="w-1/2 pb-10">
					<vs-card class="card-url">
						<div slot="header" @click.stop>
							<vs-checkbox v-model="isBySimpleSearch"></vs-checkbox>
							<h3 class="text-center">Via Search Simple</h3>
						</div>
						<div>
							<span>
								Utilisez notre moteur de recherche simplifié pour trouver
								rapidement des prospects avec son contact Linkedin.Trouvez des
								prospects en utilisant des mots-clés spécifiques à votre secteur
								d'activité en fonction de leur présence en ligne avec
								l'interface pour contacter.
							</span>
						</div>
					</vs-card>
				</div>
			</div>
		</div>
		<!-- End methods choose -->
	</div>
	<!--  -->
</template>

<script>
import store from "@/store/store";
import VueCookies from "vue-cookies";
import XLSX from "xlsx";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin.js";
import ProspectSearch from "@/entities/ProspectSearch";
import KeywordsIdeasCard from "@/components/views/dashboard/prospection/KeywordsIdeasCard.vue";
import TopKeywordEditor from "../../../components/views/dashboard/keywords/TopKeywordEditor.vue";
import validatorMixin from "../../../mixins/validatorMixin";

export default {
	name: "ProspectFirstPage",
	mixins: [dbFieldConvertor, utilsMixin, validatorMixin],
	props: {
		chartParams: Object,
		isPercent: Boolean,
		type: String,
		isEdit: {
			type: Boolean,
			default: false,
		},
		projectId: {
			type: Number,
			default: 0,
		},
	},
	components: {
		FormWizard,
		TabContent,
		WizardButton,
		flatPickr,
		KeywordsIdeasCard,
		TopKeywordEditor,
	},
	data() {
		return {
			typeDisabled: this.$props.isEdit,
			apiUrl: this.$store.state.backendApiUrl,
			isDisableSaveButton: true,
			isByUrl: false,
			isByKeyword: false,
			isBySimpleSearch: false,
			prospectSearch: ProspectSearch.getFormFields(),
			keywordsIdeaLanguageCode: null,
			topKeywords: [],
			countIncorrectUrl: 0,
			topKeywordFromSuggestion: [],
			topKeywordsEditorKey: 0,
			keywordsIdeaKey: 0,
			showModifyTopKeywords: true,
			country_list: [],
			search_engines: [],
			search_engines_langauges: [],
			prospectsURLs: [],
			editProspectKey: 0,
			urlTableKey: 0,
			countryListKey: 0,
			languageListKey: 0,
			prospectProjectDetails: {},
			runPrsopect_auto: true,
			activeTab: 0,
			isProspectTabDisable: false,
			isKeywordTabDisable: true,
			keywordsIdeasCardKey: 0,
			isProspectCollapseOpen: true,
			showAddURL: true,
			saveButtonKey: 0,
			newUrl: "",
			invalidUrlMessage: "Commencez par 'http://www.' ou 'https://www.'",
			warningMessagekey: 0,
			warningMessage: null,
			showModifyURLPopup: false,
			modifiedURL: "",
			modifiedURLIndex: null,
			detailBoxRefreshKey: 0,
			fieldValidatior: {
				name: {
					danger: false,
					message: "",
				},
				domain_activity: {
					danger: false,
					message: "",
				},
			},
		};
	},
	created() {
		//fetching with deafult values
		this.fetchSearchEngines();
		this.fetchSearchEnginesCountries(1);
		this.fetchSearchEnginesLanguages(1);

		this.keywordsIdeaKey++;
		if (this.$props.isEdit) {
			this.fetchProspectProjectDetails();
			this.fetchProspectsBysProjectDetails();
		}
	},
	computed: {
		newProspects: function () {
			return store.state.newProspects;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	watch: {
		warningMessage: function (val) {
			if (val)
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: val,
				});
		},
		topKeywords: function (val) {
			this.keywordsIdeasCardKey++;
		},
		"prospectSearch.name": function (val) {
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				name: val,
			});
		},
		"prospectSearch.domain_activity": function (val) {
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				domain_activity: val,
			});
		},
		"prospectSearch.location_id": function (val) {
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				location_id: val,
				location_code: this.country_list.find((location) => location.id === val)
					.location_code,
			});
			console.log("message", this.newProspects);
		},

		"prospectSearch.language_id": function (val) {
			let language_name = this.search_engines_languages.find(
				(language) => language.id === val
			).name;
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				langauge_id: val,
				language_name: language_name,
			});
		},
		"prospectSearch.search_engine_id": function (val) {
			this.fetchSearchEnginesCountries(val);
			this.fetchSearchEnginesLanguages(val);
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				search_engine_id: val,
			});
			// this.keywordsIdeaKey++;
		},

		prospectsURLs: function (data) {
			// for (let i = 0; i < data.length; i++) {
			// 	var pattern = /^(https?:\/\/)?(www\.)\S+$/;
			// 	if (!pattern.test(data[i].url.toLowerCase()))
			// 		this.warningMessage = "L'url doit contenir https://www.";
			// 	else this.warningMessage = null;
			// }
			// // disable save button if there is no prospect
			// this.checkDisableSaveButton();
			// this.editProspectKey++;
			// this.warningMessagekey++;
			// this.isKeywordTabDisable = false;
			// this.isProspectCollapseOpen = false;
			// this.isProspectCollapseOpen = true;
		},
		isByKeyword: function (val) {
			if (val) this.toogleType(2);
		},
		isByUrl: function (val) {
			if (val) this.toogleType(1);
		},
		isBySimpleSearch: function (val) {
			if (val) this.toogleType(3);
		},
	},
	methods: {
		/**
		 * Validate all fields in prospect search form
		 */
		validateAllField() {
			console.log("Running ProspectFirstPage validateAllField");
			let pass = true;
			// Name
			let isNameValidate = validatorMixin.methods.validatorHandler(
				this.prospectSearch.name,
				"nameConstraint"
			);
			if (
				isNameValidate &&
				isNameValidate.hasOwnProperty("specificConstraint")
			) {
				this.fieldValidatior.name.danger = true;
				this.fieldValidatior.name.message =
					isNameValidate.specificConstraint[0];
				pass = false;
			} else {
				this.fieldValidatior.name.danger = false;
				this.fieldValidatior.name.message = "";
			}
			// Domain Activity
			let isDomainActivityValidate = validatorMixin.methods.validatorHandler(
				this.prospectSearch.domain_activity,
				"nameConstraint"
			);
			if (
				isDomainActivityValidate &&
				isDomainActivityValidate.hasOwnProperty("specificConstraint")
			) {
				this.fieldValidatior.domain_activity.danger = true;
				this.fieldValidatior.domain_activity.message =
					isDomainActivityValidate.specificConstraint[0];
				pass = false;
			} else {
				this.fieldValidatior.domain_activity.danger = false;
				this.fieldValidatior.domain_activity.message = "";
			}
			return pass;
		},
		handleClick(event) {
			if (this.isDisabled) {
				event.stopImmediatePropagation();
				return;
			}
			// handle click event
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].valid == false) {
				if (name == "type") {
					return "border: 1px solid red !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				}
			} else if (this.validators[name] && this.validators[name].valid == true) {
				if (name == "type") {
					return "border: 1px solid green !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				}
			} else {
			}
		},
		toogleType(val) {
			if (val == 1) {
				this.isByUrl = true;
				this.isByKeyword = false;
				this.isBySimpleSearch = false;
			} else if (val == 2) {
				this.isByKeyword = true;
				this.isByUrl = false;
				this.isBySimpleSearch = false;
			} else if (val == 3) {
				this.isBySimpleSearch = true;
				this.isByUrl = false;
				this.isByKeyword = false;
			}
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				type: val,
			});
		},
		// toogleByUrl() {
		// 	this.isByUrl = !this.isByUrl;
		// 	this.isByKeyword = false;
		// 	this.$store.dispatch("setNewProspects", {
		// 		...this.newProspects,
		// 		isByKeyword: this.isByKeyword,
		// 		isByUrl: this.isByUrl,
		// 	});
		// },
		// toogleByKeyword() {
		// 	this.isByKeyword = !this.isByKeyword;
		// 	this.isByUrl = false;
		// 	this.$store.dispatch("setNewProspects", {
		// 		...this.newProspects,
		// 		isByKeyword: this.isByKeyword,
		// 		isByUrl: this.isByUrl,
		// 	});
		// },
		getLanguageCodeForKeywordsIdea() {
			if (this.search_engines_languages) {
				let resposne_code = this.search_engines_languages.find(
					(language) => language.id === this.prospectSearch.language_id
				);

				return resposne_code.code;
			}
		},
		getLocationCodeForKeywordsIdea() {
			if (this.country_list) {
				let resposne_code = this.country_list.find(
					(location) => location.id === this.prospectSearch.country_id
				);
				return resposne_code.location_code;
			}
		},
		validateUrl(url) {
			var pattern = /^(https?:\/\/)?(www\.)\S+$/;
			if (!pattern.test(url)) this.warningMessage = this.invalidUrlMessage;
			else this.warningMessage = null;
		},
		deleteAllProspects() {
			this.prospectsURLs = [];
		},
		handleTabChange(value) {
			// if (value == 1) this.isProspectTabDisable = true;
			this.activeTab = value;
		},
		hanldeNextTab() {
			this.activeTab++;
		},
		addUrls(urls) {
			for (let url of urls) {
				if (
					this.prospectsURLs.includes(url.url.toString().toLowerCase()) == false
				) {
					this.prospectsURLs.push({ url: url.url.toLowerCase() });
				}
			}
		},
		csvImport() {
			//console.log("csvImport");
			this.setLoading(true, "importButton");
			let inputFile = document.getElementById("fileinputtk");
			//console.log(inputFile);
			inputFile.click();
		},
		readCSV(file, prospectsURLs) {
			/*
			 * //console.log("file", file.target.result)
			 * //console.log("file", file.target.files[0])
			 */
			let reader = new FileReader();
			const callback = this.addUrls;
			reader.onload = function (e) {
				let mergedURLs = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, { type: "array" });
				/* DO SOMETHING WITH workbook HERE */
				let sheet_name_list = workbook.SheetNames;
				let fetched_URLs = XLSX.utils.sheet_to_json(
					workbook.Sheets[sheet_name_list[0]],
					{ header: 1 }
				);
				// //console.log("fetched_competitors", fetched_competitors)
				if (fetched_URLs.length > 0) {
					mergedURLs = [...prospectsURLs];
					// //console.log("mergedURLs", mergedURLs)
					mergedURLs =
						mergedURLs.length > 0 ? mergedURLs.map((url) => url.url) : [];
					fetched_URLs.forEach((row, index) => {
						if (row[0] && row[0] !== null) {
							if (!mergedURLs.includes(row[0])) {
								var pattern = /^(https?:\/\/)?(www\.)\S+$/;
								if (!pattern.test(url)) {
									this.countIncorrectUrl++;
									this.warningMessage = `${this.countIncorrectUrl} urls sont pas valides`;
								} else {
									if (index < 100)
										// if (["https", "http", "wwww"].includes(row.url))
										mergedURLs.push({ url: row[0] });
									else this.warningMessage = "Seulement 100 URLS sont importés";
								}
							}

							// //console.log("mergedURLs updated", mergedURLs)
						}
					});

					//console.log(mergedURLs);
					// let stringMergedKeywords = mergedURLs.join(',')

					callback(mergedURLs);
				}
			};

			this.setLoading(false, "importButton");
			reader.readAsArrayBuffer(file.target.files[0]).result;
			/*
			 * //console.log("mergedURLs updated 2", this.mergedURLs) // REPLACE WITH A DISPLAY SHOWING NEWLY IMPORTED KEYWORDS AND VALIDATE
			 * this.onSaveTke(this.mergedURLs)
			 */
		},
		fetchSearchEnginesCountries(id) {
			ProspectSearch.getSearchEnginesCountryList(id, (err, res) => {
				this.country_list = res;
				//making default country as france
				// this.prospectSearch.country_id = this.country_list.find(
				// 	(country) => country.location_name === "France"
				// ).id;
				this.countryListKey++;
			});
		},
		fetchSearchEngines() {
			ProspectSearch.getSearchEngines((err, res) => {
				this.search_engines = res;
			});
		},
		fetchSearchEnginesLanguages(id) {
			ProspectSearch.getSearchEnginesLanguages(id, (err, res) => {
				this.search_engines_languages = res;
				//making default language as french
				// this.prospectSearch.language_id = this.search_engines_languages.find(
				// 	(language) => language.name === "French"
				// ).id;
				this.languageListKey++;
			});
		},

		submitProspectSearch() {
			if (this.prospectsURLs.length > 0)
				this.prospectSearch["prospect_list"] = this.prospectsURLs;
			if (this.topKeywords.length > 0)
				this.prospectSearch["keyword_list"] = this.topKeywords.concat(
					this.topKeywordFromSuggestion
				);

			let prospectSearchObject = new ProspectSearch(this.newProspects);
			// ADD USER_ID
			prospectSearchObject.user_id = this.activeUser.id;
			if (!this.$props.isEdit) {
				prospectSearchObject.createProject((errCreatePS, ps_id) => {
					if (errCreatePS) {
						// NOTIFY FAILED
						this.$vs.notify({
							title: "Echec",
							color: "danger",
							text: "Le project n'a pas été ajoute.",
						});
						return;
					}
					if (ps_id) {
						this.returnPrevRoute();
						this.$vs.notify({
							title: "Succès",
							color: "success",
							text: "Le project ajoute avec succès.",
						});

						// prospectSearchObject.id = ps_id;
						// prospectSearchObject.updateProspects(
						// 	this.prospectsURLs,
						// 	(errUpdateProspects, resultUpdateProspects) => {
						// 		if (errUpdateProspects) {
						// 			// NOTIFY FAILED
						// 			return;
						// 		}
						// 		if (resultUpdateProspects) {
						// 			if (this.topKeywords.length > 0) {
						// 				prospectSearchObject.updateKeywords(
						// 					this.topKeywords,
						// 					(errUpdateKeywords, resultUpdateKeywords) => {
						// 						if (errUpdateKeywords) {
						// 							// NOTIFY FAILED
						// 							return;
						// 						}
						// 						if (resultUpdateKeywords) {
						// 							/*
						// 							 * NOTIFY OK + WAIT A BIT
						// 							 * RETURN PREVIOUS PAGE
						// 							 */
						// 							this.returnPrevRoute();
						// 						}
						// 					}
						// 				);
						// 			} else {
						// 				this.returnPrevRoute();
						// 			}
						// 		}
						// 	}
						// );
					}
				});
			} else {
				console.log("this.prospectSearch", this.prospectSearch);
				prospectSearchObject.editProject(
					this.prospectSearch.id,
					(errCreatePS, ps_id) => {
						if (errCreatePS) {
							// NOTIFY FAILED
							this.$vs.notify({
								title: "Echec",
								color: "danger",
								text: "Le project n'a pas été ajoute.",
							});
							return;
						}
						if (ps_id) {
							this.returnPrevRoute();
							this.$vs.notify({
								title: "Succès",
								color: "success",
								text: "Le project ajoute avec succès.",
							});
						}
					}
				);
			}

			/*
			 * CREATE PROSPECTSEARCH
			 * ADD PROSPECTS
			 * ADD KEYWORDS
			 */

			//console.log("submitProspectSearch");
		},

		checkRequiredFields() {
			let requiredOk = true;
			if (this.showModifyTopKeywords == true) requiredOk = false;
			if (this.prospectsURLs.length < 1) requiredOk = false;
			if (this.topKeywords.length < 1) requiredOk = false;

			return requiredOk;
		},

		displayModifyTopKeywords() {
			this.showModifyTopKeywords = true;
			this.$refs.topKeywordsEditor.setTopKeywords();
		},
		onToogleSave(toogleSave) {
			this.isDisableSaveButton = !toogleSave;
			this.saveButtonKey++;
		},
		updateAndHideModifyTopKeywords(tks) {
			this.showModifyTopKeywords = false;

			this.topKeywords = tks;
			this.saveButtonKey++;
			this.keywordsIdeaKey++;

			this.checkDisableSaveButton();
			// this.showModifyTopKeywords = false;
		},
		updateKeywordsFromSuggestion(tks) {
			this.topKeywordFromSuggestion = tks;
			this.saveButtonKey++;
			this.topKeywordsEditorKey++;
			// this.keywordsIdeaKey++;
			this.checkDisableSaveButton();
			// this.showModifyTopKeywords = false;
		},
		checkDisableSaveButton() {
			if (this.topKeywords.length > 0 && this.prospectsURLs.length > 0)
				this.isDisableSaveButton = false;
			else this.isDisableSaveButton = true;
		},
		cancelAndHideModifyTopKeywords() {
			this.showModifyTopKeywords = false;
		},
		addURL(url) {
			var pattern = /^(https?:\/\/)?(www\.)\S+$/;
			if (!pattern.test(url)) {
				this.warningMessage = `${url} est pas valide. ${this.invalidUrlMessage}`;
			} else {
				if (url) {
					this.prospectsURLs.push({ url: url });
					this.newUrl = "";
				}
				this.showAddURL = false;
			}
		},
		displayAddUrl() {
			this.showAddURL = true;
		},

		updateURL(index, row) {
			this.modifiedURL = row;
			this.modifiedURLIndex = index;
			this.showModifyURLPopup = true;
		},
		modifyURL() {
			this.prospectsURLs[this.modifiedURLIndex].url = this.modifiedURL;
			this.urlTableKey++;
			this.validateUrl(this.modifiedURL);
			this.showModifyURLPopup = false;
		},
		async fetchProspectProjectDetails() {
			this.prospectSearch = await ProspectSearch.fetchProspectProjectDetails(
				this.$route.params.psId
			);
			this.detailBoxRefreshKey++;
		},
		async fetchProspectsBysProjectDetails() {
			this.prospectsURLs = await ProspectSearch.getProspectByProjectId(
				this.$route.params.psId
			);
			this.assignKeywordsTableHeader(this.prospectsURLs);
		},
		// async fetchKeywordsBysProjectDetails() {
		// 	this.prospectsURLs = await ProspectSearch.getProspectByProjectId(
		// 		this.$route.params.psId
		// 	);
		// 	console.log("message", this.prospectsURLs);
		// 	this.assignKeywordsTableHeader(this.prospectsURLs);
		// 	this.prospectsURLs = this.prospectsURLs.map((url) => url.url);
		// },
		assignKeywordsTableHeader(prospectsList) {
			// Flatten all keywords from all prospects into a single array
			const allKeywords = prospectsList.flatMap((prospect) =>
				prospect.keywords.map((keyword) => keyword)
			);
			// Object to store unique keywords and their corresponding objects
			const uniqueKeywordsMap = {};

			// Iterate through the object list
			allKeywords.forEach((obj) => {
				// Check if the keyword already exists in the map
				if (!uniqueKeywordsMap.hasOwnProperty(obj.keyword)) {
					// If it doesn't exist, add it to the map with its corresponding object
					uniqueKeywordsMap[obj.keyword] = obj;
				}
			});

			// Extract the unique objects from the map
			const uniqueObjects = Object.values(uniqueKeywordsMap);
			// Use Set to get unique keywords
			this.topKeywords = uniqueObjects;
			this.topKeywordsEditorKey++;
			// this.prospectsListKey++;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.warning-panel {
	background-color: #ffe0b2; /* Light orange */
	color: #b71c1c; /* Dark red */
	padding: 10px;
	border: 2px solid #ff9800; /* Orange border */
	border-radius: 5px;
	margin-bottom: 10px;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}
.card-url:hover {
	cursor: pointer;
	transform: scale(1.05);
	transition: transform 0.3s ease;
}
.disabled-div {
	pointer-events: none;
	opacity: 0.5;
}
</style>
